
function read<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) as T : fallback;
  } catch {
    return fallback;
  }
}

function write<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch { void 0; }
}

export interface SiteConfig {
  show_title: boolean;
  site_title: string;
  logo_url: string;
  logo_width: number;
  logo_height: number;
  hero_image_url: string;
  hero_image_scale: 'cover' | 'contain' | 'fill';
  hero_image_position: 'center' | 'top' | 'bottom' | 'left' | 'right' | 'left-top' | 'right-top' | 'left-bottom' | 'right-bottom';
  hero_title: string;
  hero_subtitle: string;
}

export const siteConfigService = {
  async getSiteConfig(): Promise<SiteConfig> {
    try {
      const data = await apiClient.get('/site-config');
      const defaults = getDefaultConfig();
      const stored = (data || {}) as Partial<SiteConfig>;
      return {
        show_title: stored.show_title ?? defaults.show_title,
        site_title: stored.site_title ?? defaults.site_title,
        logo_url: stored.logo_url ?? defaults.logo_url,
        logo_width: stored.logo_width ?? defaults.logo_width,
        logo_height: stored.logo_height ?? defaults.logo_height,
        hero_image_url: stored.hero_image_url ?? defaults.hero_image_url,
        hero_image_scale: stored.hero_image_scale ?? defaults.hero_image_scale,
        hero_image_position: stored.hero_image_position ?? defaults.hero_image_position,
        hero_title: stored.hero_title ?? defaults.hero_title,
        hero_subtitle: stored.hero_subtitle ?? defaults.hero_subtitle,
      };
    } catch {
      const stored = read<Partial<SiteConfig>>('site_config', {});
      const defaults = getDefaultConfig();
      return {
        show_title: stored.show_title ?? defaults.show_title,
        site_title: stored.site_title ?? defaults.site_title,
        logo_url: stored.logo_url ?? defaults.logo_url,
        logo_width: stored.logo_width ?? defaults.logo_width,
        logo_height: stored.logo_height ?? defaults.logo_height,
        hero_image_url: stored.hero_image_url ?? defaults.hero_image_url,
        hero_image_scale: stored.hero_image_scale ?? defaults.hero_image_scale,
        hero_image_position: stored.hero_image_position ?? defaults.hero_image_position,
        hero_title: stored.hero_title ?? defaults.hero_title,
        hero_subtitle: stored.hero_subtitle ?? defaults.hero_subtitle,
      };
    }
  },

  async updateSiteConfig(updates: Partial<SiteConfig>): Promise<void> {
    try {
      await apiClient.put('/site-config', updates);
    } catch {
      const current = read<Partial<SiteConfig>>('site_config', {});
      const merged = { ...current, ...updates };
      write('site_config', merged);
    }
  }
};

function getDefaultConfig(): SiteConfig {
  return {
    show_title: true,
    site_title: 'VINTAGE LITERAL',
    logo_url: '',
    logo_width: 40,
    logo_height: 40,
    hero_image_url: '',
    hero_image_scale: 'cover',
    hero_image_position: 'left-top',
    hero_title: 'VINTAGE LITERAL',
    hero_subtitle: 'Explora la literatura\ncon mirada retro',
  };
}
import { apiClient } from './apiClient';
